import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return VueRouterPush.call(this, location).catch(err => err)
}
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return VueRouterReplace.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    // 产品介绍页
    {
        path:'/index',
        name:'index',
        component:() => import('../views/index/index.vue')
    
    },
    {
        path:'/login',
        name:'Login',
        component:() => import('../views/login/login.vue')
    
    },

    /**           机构               */
    {
        path:'/org',
        name:'org',
        meta:{
            title:'首页',
          },
        component:() => import('../views/org/org.vue')
    
    },

     /**           用户               */
     {
        path:'/home',
        name:'home',
        meta:{
            title:'首页',
          },
        component:() => import('../views/user/home.vue')
    
    },
    {
        path:'/user',
        name:'user',
        meta:{
            title:'文件管理',
          },
        component:() => import('../views/user/index.vue')
    
    },
    // guide 使用指南
    {
        path:'/guide',
        name:'guide',
        meta:{
            title:'用户指南',
          },
        component:() => import('../views/user/guide.vue')
    
    },
    {
        path:'/orgGuide',
        name:'orgGuide',
        meta:{
            title:'用户指南',
          },
        component:() => import('../views/user/orgGuide.vue')
    
    },
    {
        path:'/folder',
        name:'folder',
        component:() => import('../views/user/folder.vue')
    
    },
    {
        path:'/uplound',
        name:'uplound',
        meta:{
            title:'文件上传',
          },
        component:() => import('../views/user/uplound.vue')
    
    },
    // personal 个人中心
    {
        path:'/personal',
        name:'personal',
        component:() => import('../views/personal/index.vue')
    
    },
    // 任务详情
    {
        path:'/details',
        name:'details',
        component:() => import('../views/personal/details.vue')
    
    },
 
]

const router = new VueRouter({
  routes
})

export default router
